/**
 * ODDFISH — OMF case study page
 * Matches live oddfishmedia.com.au/case-studies/omf/ scroll, AOS, slick + counters
 */
(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");
  var countersStarted = false;

  function prefersReducedMotion() {
    return REDUCED.matches;
  }

  function initAos() {
    if (typeof AOS === "undefined") return;

    if (!window.__oddfishOmfAosInit) {
      AOS.init({
        once: true,
        duration: 800,
        easing: "ease-out-cubic",
        offset: 120,
        disable: prefersReducedMotion()
      });
      window.__oddfishOmfAosInit = true;
    } else {
      AOS.refresh();
    }
  }

  function revealStrike(strike) {
    if (!strike || strike.dataset.omfStrikeDone === "true") return;

    if (prefersReducedMotion()) {
      strike.dataset.omfStrikeDone = "true";
      strike.classList.add("strike-visible");
      return;
    }

    strike.classList.remove("strike-visible");
    void strike.offsetWidth;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        strike.dataset.omfStrikeDone = "true";
        strike.classList.add("strike-visible");
      });
    });
  }

  function bindStrikeReveal(strike) {
    if (!("IntersectionObserver" in window)) {
      revealStrike(strike);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          window.setTimeout(function () {
            revealStrike(strike);
          }, 200);
          observer.unobserve(strike);
        });
      },
      { threshold: 0.3, rootMargin: "0px 0px -10% 0px" }
    );

    observer.observe(strike);
  }

  function playAosElement(el) {
    if (!el || !el.hasAttribute("data-aos")) return;
    if (el.classList.contains("aos-animate")) return;
    el.classList.add("aos-init");
    el.classList.add("aos-animate");
  }

  function playSectionAos(section) {
    section.querySelectorAll("[data-aos]").forEach(function (el) {
      if (el.matches(".title_section") || el.querySelector(":scope > .strike")) return;
      playAosElement(el);
    });

    section.querySelectorAll(".media_wrapper .left_side").forEach(playAosElement);
    section.querySelectorAll(".media_wrapper .right_side").forEach(playAosElement);
    section.querySelectorAll(".media_inner_quote .quote").forEach(playAosElement);
    section.querySelectorAll(".section_inner .content_area_right").forEach(playAosElement);
    section.querySelectorAll(".gallery_image").forEach(playAosElement);
  }

  function triggerAnimateSection(section) {
    if (section.dataset.omfScrolled === "true") return;
    section.dataset.omfScrolled = "true";
    section.classList.add("scrolled");
    playSectionAos(section);
  }

  function initStrikes(page) {
    page.querySelectorAll(".case_flexable h2.strike").forEach(function (strike) {
      if (strike.dataset.omfStrikeBound === "true") return;
      strike.dataset.omfStrikeBound = "true";
      bindStrikeReveal(strike);
    });

    page.querySelectorAll(".media_wrapper .strike, .what_they_say .strike").forEach(function (strike) {
      if (strike.dataset.omfStrikeBound === "true") return;
      strike.dataset.omfStrikeBound = "true";
      bindStrikeReveal(strike);
    });
  }

  function animateCounters(page) {
    if (countersStarted) return;

    var counters = page.querySelectorAll(".case_counter");
    if (!counters.length) return;

    countersStarted = true;

    counters.forEach(function (counter) {
      var countTo = parseInt(counter.getAttribute("data-count"), 10);
      if (isNaN(countTo)) return;

      if (typeof jQuery !== "undefined" && jQuery.fn && !prefersReducedMotion()) {
        var $counter = jQuery(counter);
        jQuery({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 1300,
            easing: "linear",
            step: function () {
              $counter.text(Math.floor(this.countNum));
            },
            complete: function () {
              $counter.text(countTo);
            }
          }
        );
      } else {
        counter.textContent = String(countTo);
      }
    });
  }

  function initStats(page) {
    var statsSection = page.querySelector(".stats");
    if (!statsSection || statsSection.dataset.omfStatsBound === "true") return;
    statsSection.dataset.omfStatsBound = "true";

    function runStats() {
      animateCounters(page);
      initLottie(page);
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) runStats();
          });
        },
        { threshold: 0.2, rootMargin: "0px 0px -40px 0px" }
      ).observe(statsSection);
    }

    if (isSectionVisible(statsSection)) runStats();
  }

  function isSectionVisible(section) {
    var rect = section.getBoundingClientRect();
    return rect.top < window.innerHeight - 40 && rect.bottom > 40;
  }

  function handleScroll(page) {
    var bottomOfWindow = window.scrollY + window.innerHeight;

    page.querySelectorAll(".animate").forEach(function (section) {
      var bottomOfSection = section.offsetTop + section.offsetHeight - 50;

      if (bottomOfWindow > bottomOfSection) {
        triggerAnimateSection(section);
      }
    });

    page.querySelectorAll(".gallery.animate").forEach(function (section) {
      if (section.dataset.omfScrolled === "true") return;
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        triggerAnimateSection(section);
      }
    });
  }

  function initBillboardSlider(page) {
    var slider = page.querySelector(".billboard .slider");
    if (!slider || typeof jQuery === "undefined" || !jQuery.fn.slick) return;
    if (jQuery(slider).hasClass("slick-initialized")) return;

    jQuery(slider).slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      autoplay: !prefersReducedMotion(),
      autoplaySpeed: 4000,
      fade: true,
      cssEase: "linear",
      pauseOnHover: true
    });
  }

  function initPhoneSlider(page) {
    var slider = page.querySelector(".slider_bottom");
    if (!slider || typeof jQuery === "undefined" || !jQuery.fn.slick) return;
    if (jQuery(slider).hasClass("slick-initialized")) return;

    jQuery(slider).slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function initCaseStrikeHover(page) {
    page.querySelectorAll(".case_strike.striker").forEach(function (btn) {
      if (btn.dataset.omfStrikerBound === "true") return;
      btn.dataset.omfStrikerBound = "true";

      btn.addEventListener("mouseenter", function () {
        btn.classList.add("striker-visible");
      });
      btn.addEventListener("mouseleave", function () {
        btn.classList.remove("striker-visible");
      });
      btn.addEventListener("focus", function () {
        btn.classList.add("striker-visible");
      });
      btn.addEventListener("blur", function () {
        btn.classList.remove("striker-visible");
      });
    });
  }

  function initBannerStrike(page) {
    page.querySelectorAll(".single_case_banner .strike").forEach(revealStrike);
  }

  function initLottie(page) {
    var player = page.querySelector("lottie-player");
    if (!player || player.dataset.lottieInit === "true") return;

    function setup() {
      if (player.dataset.lottieInit === "true") return;
      player.dataset.lottieInit = "true";

      if (typeof player.play === "function") {
        player.play();
      }

      if (prefersReducedMotion()) return;

      if (typeof LottieInteractivity !== "undefined") {
        try {
          LottieInteractivity.create({
            player: player,
            mode: "cursor",
            actions: [{ type: "hover", forceFlag: false }]
          });
        } catch (error) {
          /* optional enhancement */
        }
      }
    }

    player.addEventListener("ready", setup);
    player.addEventListener("load", setup);

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined("lottie-player").then(function () {
        setTimeout(setup, 100);
      });
    }

    setTimeout(setup, 1500);
  }

  function initOmfPage(root) {
    var page =
      (root && root.querySelector ? root.querySelector(".oddfish-case-study-omf-page") : null) ||
      document.querySelector(".oddfish-case-study-omf-page");
    if (!page || page.dataset.oddfishOmfInit === "true") return;

    page.dataset.oddfishOmfInit = "true";
    initAos();
    initBannerStrike(page);
    initStrikes(page);
    initCaseStrikeHover(page);
    initStats(page);

    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll(page);
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      "resize",
      function () {
        handleScroll(page);
      },
      { passive: true }
    );

    handleScroll(page);
    initSlidersWhenReady(page);

    setTimeout(function () {
      initAos();
      handleScroll(page);
    }, 400);

    setTimeout(function () {
      initAos();
      handleScroll(page);
    }, 1200);
  }

  function initSlidersWhenReady(page) {
    if (typeof jQuery === "undefined" || !jQuery.fn || !jQuery.fn.slick) {
      window.requestAnimationFrame(function () {
        initSlidersWhenReady(page);
      });
      return;
    }

    initBillboardSlider(page);
    initPhoneSlider(page);
  }

  function boot() {
    initOmfPage(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("load", function () {
    initAos();
    var page = document.querySelector(".oddfish-case-study-omf-page");
    if (page) {
      handleScroll(page);
      initSlidersWhenReady(page);
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".oddfish-case-study-omf-page")) {
      countersStarted = false;
      var page = event.target.querySelector(".oddfish-case-study-omf-page");
      if (page) {
        delete page.dataset.oddfishOmfInit;
        page.querySelectorAll("[data-omf-strike-bound]").forEach(function (el) {
          delete el.dataset.omfStrikeBound;
          delete el.dataset.omfStrikeDone;
        });
        page.querySelectorAll(".animate").forEach(function (el) {
          delete el.dataset.omfScrolled;
        });
        page.querySelectorAll(".stats").forEach(function (el) {
          delete el.dataset.omfStatsBound;
        });
      }
      initOmfPage(event.target);
    }
  });

  REDUCED.addEventListener("change", function () {
    countersStarted = false;
    var page = document.querySelector(".oddfish-case-study-omf-page");
    if (!page) return;
    delete page.dataset.oddfishOmfInit;
    page.querySelectorAll(".animate").forEach(function (el) {
      delete el.dataset.omfScrolled;
    });
    boot();
  });
})();
